module.exports = __webpack_public_path__ + "img/raffle-banner.bc36448f.jpg";